import { AttachmentIcon } from "@chakra-ui/icons";
import React from "react";
import brand1 from "../assets/image/brand1.png";
import brand2 from "../assets/image/brand2.png";
import brand3 from "../assets/image/brand3.png";
import brand4 from "../assets/image/brand4.png";
import brand5 from "../assets/image/brand5.png";
const Services = () => {
  return (
    <>
    <div className="pt-[100px] animate__animated  animate__backInRight ">
          <img
            className="h-full\ w-full object-contain"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fservices_headings.c8934f7b.png&w=1920&q=75"
            alt="img"
          />
        </div>
      <section className="p-[5%]">
        

        <div
          id="services__first"
          className="mx-[3%] flex flex-row space-x-10 p-[5%] text-[#6b6b6b] max-md:flex-col max-md:gap-5"
        >
          <div className="flex w-[60%] flex-col gap-4 max-md:w-full ">
            <h1 className="text-[36px] font-semibold text-[#157a70] max-md:text-[20px]">
              ELEVATE YOUR APP WITH ACCURATE DATA
            </h1>
            <p className="text-[16px] max-md:text-[12px]">
              Data stands as the cornerstone of informed decision-making. The
              ability to glean insights, understand trends, and harness
              actionable intelligence has become not only a strategic advantage
              but a necessity. We understand the transformative power of data,
              and our comprehensive Data Services are designed to empower your
              app is journey to success.
            </p>
            <div className="flex flex-col gap-2 pl-12 ">
              <div className="flex gap-2">
                <i>
                  <AttachmentIcon />
                </i>
                <p className="text-[16px] max-md:text-[9px] ">
                  Driving Decisions with Data: Our Services provide a clear
                  roadmap, enabling you to decipher the story hidden within the
                  numbers.
                </p>
              </div>
              <div className="flex gap-2">
                <i>
                  <AttachmentIcon />
                </i>
                <p className="text-[16px] max-md:text-[9px]">
                  Precise Insights for Informed Strategies: Dive into user
                  behaviors, preferences, and engagement patterns. Tailor your
                  strategies with pinpoint accuracy, aligning your app is
                  features and marketing efforts precisely with user
                  expectations.
                </p>
              </div>
              <div className="flex gap-2">
                <i>
                  <AttachmentIcon />
                </i>
                <p className="text-[16px] max-md:text-[9px]">
                  Competitor Analysis for a Competitive Edge: Gain insights into
                  other app performances, user acquisition strategies, and
                  emerging trends. Fine-tune your own app offerings and
                  marketing approach, ensuring you stand out.
                </p>
              </div>
            </div>
          </div>

          <div>
            <img
              src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fservice_img1.9254a3bb.png&w=640&q=75"
              alt="img"
            />
          </div>
        </div>

        <div id="services__second" className="">
          <h1 className="pb-5 text-left text-[36px] font-semibold text-[#157a70] max-md:w-full max-md:items-center max-md:text-center max-md:text-[25px]">
            THE DATA-DRIVEN JOURNEY
          </h1>
          <div
            id="services__second__content"
            className="flex items-center justify-evenly gap-5 max-md:flex-col "
          >
            <div className="flex w-[30%] flex-col gap-2 max-md:w-full max-md:items-center max-md:text-center ">
              <img
                className="h-[70px] max-h-[100%] w-[70px] max-w-[100%] object-contain"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhome_engage_img1.649735d4.png&w=96&q=75"
                alt="img"
              />
              <h1 className="text-[24px] font-semibold text-[#157a70] max-md:text-[20px] ">
                Mapping the Terrain
              </h1>
              <p className="text-[16px] max-md:text-[12px]">
                The journey begins with data discovery and collection. We work
                collaboratively to identify the metrics that matter most to your
                app is objectives. Through meticulous data collection methods,
                we capture valuable user interactions, behaviors, and patterns.
                This foundational step sets the stage for a deeper understanding
                of your audience and their preferences.
              </p>
            </div>

            <div className="flex w-[30%] flex-col gap-2 max-md:w-full max-md:items-center max-md:text-center">
              <img
                className="h-[70px] max-h-[100%] w-[70px] max-w-[100%] object-contain"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhome_engage_img1.649735d4.png&w=96&q=75"
                alt="img"
              />
              <h1 className="text-[24px] font-semibold text-[#157a70] max-md:text-[20px]">
                Navigating the Path
              </h1>
              <p className="text-[16px] max-md:text-[12px]">
                With a wealth of data at hand, we analyze and interpret the
                intricate web of information. Uncovering meaningful patterns and
                correlations, we decipher the story that data tells. This phase
                involves cutting-edge tools and methodologies to extract
                insights that guide your strategic decisions. Our goal is to
                transform data into a clear navigational path, and optimize user
                experiences to drive engagement.
              </p>
            </div>

            <div className="flex w-[30%] flex-col gap-2 max-md:w-full max-md:items-center max-md:text-center">
              <img
                className="h-[70px] max-h-[100%] w-[70px] max-w-[100%] object-contain"
                src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhome_engage_img1.649735d4.png&w=96&q=75"
                alt="img"
              />
              <h1 className="text-[24px] font-semibold text-[#157a70] max-md:text-[20px]">
                Reaching the Destination
              </h1>
              <p className="text-[16px] max-md:text-[12px]">
                We collaboratively develop tailored solutions that align with
                your app is goals. Feature enhancements to targeted marketing
                initiatives. Pave the way for app optimization, heightened user
                satisfaction, and sustainable growth. The data-driven journey
                does not end here. It is a continuous loop of discovery,
                analysis, and implementation. We are dedicated to ensure your
                app reaches new heights of success fueled by the power of data.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div
        id="services__third"
        className=" flex h-[100px] flex-row items-center  justify-evenly gap-3  bg-[#157a704d] px-3 md:h-[200px] "
      >
        <img
          src={brand1}
          alt="brand1"
          className="h-[50%] max-h-full w-[15%] max-w-full object-contain md:w-[20vh] "
        />
        <img
          src={brand2}
          alt="brand1"
          className="h-[50%] max-h-full w-[15%] max-w-full object-contain md:w-[20vh] "
        />
        <img
          src={brand3}
          alt="brand1"
          className="h-[50%] max-h-full w-[15%] max-w-full object-contain md:w-[20vh] "
        />
        <img
          src={brand4}
          alt="brand1"
          className="h-[50%] max-h-full w-[15%] max-w-full object-contain md:w-[20vh] "
        />
        <img
          src={brand5}
          alt="brand1"
          className="h-[50%] max-h-full w-[15%] max-w-full object-contain md:w-[20vh] "
        />
      </div>
      <div
        id="services__fourth"
        className="mx-[3%] flex flex-row space-x-10 p-[5%] text-[#6b6b6b] max-md:flex-col max-md:gap-5"
      >
        <div className="flex w-[60%] flex-col items-center justify-center gap-4 max-md:w-full ">
          <h1 className="text-[36px] font-semibold text-[#157a70] max-md:text-[20px]">
            STRATEGIC MARKETING INTELLIGENCE
          </h1>
          <p className="text-[16px] max-md:text-[12px]">
            We uncover new potential within the gaming industry by identifying
            valuable market opportunities that have yet to be explored. Direct
            your attention towards the pivotal aspects of monetization and
            engagement strategies that truly make a difference.
          </p>
          <div className="flex flex-col gap-2 pl-12 ">
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[16px] max-md:text-[9px] ">
                Crafting the right targeted strategies will empower your
                business to grow in a competitive market, ensuring that every
                move you make is impactful.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[16px] max-md:text-[9px]">
                Stay ahead of evolving trends and equip your business with the
                ability to make important business decisions at a faster pace.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[16px] max-md:text-[9px]">
                We prioritize the development of our roadmap based on features
                that hold tangible and significant value for you. Our commitment
                is to ensure that every enhancement we introduce directly aligns
                with your expectations, fostering an optimal user experience
                that you can trust and rely on.
              </p>
            </div>
          </div>
        </div>

        <div>
          <img
            className="rounded-2xl"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fservice_img2.c276368b.png&w=640&q=75"
            alt="img"
          />
        </div>
      </div>

      <div
        id="services__fifth"
        className="mx-[3%] flex flex-row-reverse space-x-13 gap-10 p-[5%] text-[#6b6b6b] max-md:flex-col max-md:gap-5"
      >
        <div className="flex w-[60%] flex-col items-center justify-center gap-4 max-md:w-full ">
          <h1 className="text-[36px] font-semibold text-[#157a70] max-md:text-[20px]">
            GAIN VALUABLE INSIGHTS ON THE GREATER APP ECONOMY
          </h1>
          <p className="text-[16px] max-md:text-[12px]">
            You will get more than just navigate the competitive landscape. We
            are here to strategically position your product for success,
            outperform your competitors, and keep driving your app development
          </p>
          <div className="flex flex-col gap-2 pl-12 ">
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[16px] max-md:text-[9px] ">
                Elevating your competitive edge: Gain insights into how and when
                competitors promote their products across various channels. we
                provide detailed analytics on spending and impressions, helping
                you make informed investment decisions.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[16px] max-md:text-[9px]">
                Seize opportunities and expertly navigate challenges by
                competitor insights (strategies, strengths, and weaknesses,...)
                and gain competitive edge.
              </p>
            </div>
            <div className="flex gap-2">
              <i>
                <AttachmentIcon />
              </i>
              <p className="text-[16px] max-md:text-[9px]">
                By understanding market gaps, user preferences, and emerging
                trends through competitive analysis, you can shape your app
                roadmap to surpass user expectations.
              </p>
            </div>
          </div>
        </div>

        <div>
          <img
            className="rounded-2xl"
            src="https://beyondsolutionz.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fservice_img3.cf18b95a.png&w=750&q=75"
            alt="img"
          />
        </div>
      </div>
    </>
  );
};

export default Services;
